var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMove = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Move"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 227",
    x: 0.5,
    y: 12,
    width: 19,
    height: 2,
    rx: 1,
    fill: "#4B5675"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 229",
    x: 0.5,
    width: 19,
    height: 2,
    rx: 1,
    fill: "#4B5675"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 228",
    x: 0.5,
    y: 6,
    width: 19,
    height: 2,
    rx: 1,
    fill: "#4B5675"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMove);
export default ForwardRef;